var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.651296,0,0,0.651296,400.65,414.543)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-400,-400)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.749028,0.00619813,-0.0118089,1.42708,173.921,-178.088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.333,153.016C143.333,142.938 127.744,134.755 108.542,134.755C89.34,134.755 73.75,142.938 73.75,153.016L73.75,658.373C73.75,668.451 89.34,676.634 108.542,676.634C127.744,676.634 143.333,668.451 143.333,658.373L143.333,153.016Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.736002,0.0069335,-0.0134436,1.42706,475.19,-178.175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.333,152.699C143.333,142.795 127.744,134.755 108.542,134.755C89.34,134.755 73.75,142.795 73.75,152.699L73.75,658.69C73.75,668.593 89.34,676.634 108.542,676.634C127.744,676.634 143.333,668.593 143.333,658.69L143.333,152.699Z",
    style: {
      fill: "white"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.879006947791d8ff5f350187bb656b4f.svg";
export { ForwardRef as ReactComponent };